/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** DateTime custom scalar type */
  DateTime: any;
};

export type ChartData = {
  __typename?: 'ChartData';
  barChartCurrentData: Array<Scalars['Float']>;
  barChartHistoricalData: Array<Scalars['Float']>;
  barChartLabels: Array<Scalars['String']>;
  currentPeriod?: Maybe<TimeSeries>;
  longPeriod?: Maybe<TimeSeries>;
  midPeriod?: Maybe<TimeSeries>;
  previousPeriod?: Maybe<TimeSeries>;
};

export type Entry = {
  __typename?: 'Entry';
  id: Scalars['ID'];
  quantity: Scalars['Float'];
  timestamp: Scalars['DateTime'];
};

export type EntryConnection = {
  __typename?: 'EntryConnection';
  edges: Array<EntryEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type EntryEdge = {
  __typename?: 'EntryEdge';
  node: Entry;
};

export type EntryInput = {
  id?: InputMaybe<Scalars['ID']>;
  quantity?: InputMaybe<Scalars['Float']>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  trackerId?: InputMaybe<Scalars['ID']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  deleteEntry: Scalars['Boolean'];
  deleteTracker: Scalars['Boolean'];
  upsertEntry: Entry;
  upsertTracker: Tracker;
};


export type MutationDeleteEntryArgs = {
  entryId: Scalars['String'];
};


export type MutationDeleteTrackerArgs = {
  trackerId: Scalars['String'];
};


export type MutationUpsertEntryArgs = {
  entry: EntryInput;
};


export type MutationUpsertTrackerArgs = {
  tracker: TrackerInput;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  getEntries: EntryConnection;
  me: User;
};


export type QueryGetEntriesArgs = {
  trackerId: Scalars['String'];
};

export type TimeSeries = {
  __typename?: 'TimeSeries';
  data: Array<TimeSeriesDataPoint>;
  label: Scalars['String'];
};

export type TimeSeriesDataPoint = {
  __typename?: 'TimeSeriesDataPoint';
  x: Scalars['DateTime'];
  y: Scalars['Float'];
};

export type Tracker = {
  __typename?: 'Tracker';
  chartData: ChartData;
  endOfDayHour?: Maybe<Scalars['Int']>;
  entries: EntryConnection;
  goal?: Maybe<TrackerGoal>;
  id: Scalars['ID'];
  name: Scalars['String'];
  timePeriod?: Maybe<TrackerTimePeriod>;
};


export type TrackerEntriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type TrackerConnection = {
  __typename?: 'TrackerConnection';
  edges: Array<TrackerEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type TrackerEdge = {
  __typename?: 'TrackerEdge';
  node: Tracker;
};

export enum TrackerGoal {
  Decrease = 'DECREASE',
  Increase = 'INCREASE'
}

export type TrackerInput = {
  endOfDayHour?: InputMaybe<Scalars['Int']>;
  goal?: InputMaybe<TrackerGoal>;
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  timePeriod?: InputMaybe<TrackerTimePeriod>;
};

export enum TrackerTimePeriod {
  Daily = 'DAILY',
  Weekly = 'WEEKLY'
}

export type User = {
  __typename?: 'User';
  email: Scalars['String'];
  id: Scalars['ID'];
  tracker: Tracker;
  trackers: TrackerConnection;
};


export type UserTrackerArgs = {
  id: Scalars['ID'];
};


export type UserTrackersArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};

export type UpsertTrackerMutationVariables = Exact<{
  tracker: TrackerInput;
}>;


export type UpsertTrackerMutation = { __typename?: 'Mutation', upsertTracker: { __typename?: 'Tracker', id: string, name: string, goal?: TrackerGoal | null, timePeriod?: TrackerTimePeriod | null, endOfDayHour?: number | null } };

export type GetTrackersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTrackersQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, trackers: { __typename?: 'TrackerConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, edges: Array<{ __typename?: 'TrackerEdge', node: { __typename?: 'Tracker', id: string, name: string, goal?: TrackerGoal | null, timePeriod?: TrackerTimePeriod | null, endOfDayHour?: number | null } }> } } };

export type DeleteTrackerMutationVariables = Exact<{
  trackerId: Scalars['String'];
}>;


export type DeleteTrackerMutation = { __typename?: 'Mutation', deleteTracker: boolean };

export type AddEntryMutationVariables = Exact<{
  entry: EntryInput;
}>;


export type AddEntryMutation = { __typename?: 'Mutation', upsertEntry: { __typename?: 'Entry', id: string, timestamp: any, quantity: number } };

export type DeleteEntryMutationVariables = Exact<{
  entryId: Scalars['String'];
}>;


export type DeleteEntryMutation = { __typename?: 'Mutation', deleteEntry: boolean };

export type UpdateEntryMutationVariables = Exact<{
  entry: EntryInput;
}>;


export type UpdateEntryMutation = { __typename?: 'Mutation', upsertEntry: { __typename?: 'Entry', id: string, timestamp: any, quantity: number } };

export type GetEntriesQueryVariables = Exact<{
  id: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
}>;


export type GetEntriesQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, tracker: { __typename?: 'Tracker', id: string, name: string, goal?: TrackerGoal | null, entries: { __typename?: 'EntryConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null }, edges: Array<{ __typename?: 'EntryEdge', node: { __typename?: 'Entry', id: string, timestamp: any, quantity: number } }> }, chartData: { __typename?: 'ChartData', barChartLabels: Array<string>, barChartHistoricalData: Array<number>, barChartCurrentData: Array<number>, currentPeriod?: { __typename?: 'TimeSeries', label: string, data: Array<{ __typename?: 'TimeSeriesDataPoint', x: any, y: number }> } | null, previousPeriod?: { __typename?: 'TimeSeries', label: string, data: Array<{ __typename?: 'TimeSeriesDataPoint', x: any, y: number }> } | null, midPeriod?: { __typename?: 'TimeSeries', label: string, data: Array<{ __typename?: 'TimeSeriesDataPoint', x: any, y: number }> } | null, longPeriod?: { __typename?: 'TimeSeries', label: string, data: Array<{ __typename?: 'TimeSeriesDataPoint', x: any, y: number }> } | null } } } };


export const UpsertTrackerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertTracker"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tracker"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TrackerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertTracker"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"tracker"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tracker"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"goal"}},{"kind":"Field","name":{"kind":"Name","value":"timePeriod"}},{"kind":"Field","name":{"kind":"Name","value":"endOfDayHour"}}]}}]}}]} as unknown as DocumentNode<UpsertTrackerMutation, UpsertTrackerMutationVariables>;
export const GetTrackersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTrackers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"trackers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"goal"}},{"kind":"Field","name":{"kind":"Name","value":"timePeriod"}},{"kind":"Field","name":{"kind":"Name","value":"endOfDayHour"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetTrackersQuery, GetTrackersQueryVariables>;
export const DeleteTrackerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteTracker"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"trackerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteTracker"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"trackerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"trackerId"}}}]}]}}]} as unknown as DocumentNode<DeleteTrackerMutation, DeleteTrackerMutationVariables>;
export const AddEntryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddEntry"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entry"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EntryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertEntry"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"entry"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entry"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}}]}}]}}]} as unknown as DocumentNode<AddEntryMutation, AddEntryMutationVariables>;
export const DeleteEntryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteEntry"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteEntry"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"entryId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entryId"}}}]}]}}]} as unknown as DocumentNode<DeleteEntryMutation, DeleteEntryMutationVariables>;
export const UpdateEntryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateEntry"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entry"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EntryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertEntry"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"entry"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entry"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}}]}}]}}]} as unknown as DocumentNode<UpdateEntryMutation, UpdateEntryMutationVariables>;
export const GetEntriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEntries"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tracker"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"goal"}},{"kind":"Field","name":{"kind":"Name","value":"entries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"chartData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentPeriod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"previousPeriod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"midPeriod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"longPeriod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"barChartLabels"}},{"kind":"Field","name":{"kind":"Name","value":"barChartHistoricalData"}},{"kind":"Field","name":{"kind":"Name","value":"barChartCurrentData"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetEntriesQuery, GetEntriesQueryVariables>;